<template>
    <button
        type="button"
        :class="[
            'box-border rounded-lg border px-10 py-4 text-center transition-all duration-200',
            active
                ? 'border-2 border-primary bg-[rgba(182,209,196,0.3)]'
                : 'm-[1px] border border-neutral-lighter',
        ]"
        @click="toggleClick"
    >
        <span>{{ text }}</span>
    </button>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ButtonToggle extends Vue {
    @Prop({ type: String, default: '' }) text;
    @Prop({ type: Boolean, default: false }) active;

    toggleClick() {
        this.$emit('toggle');
    }
}
</script>

<style scoped lang="postcss">
input {
    opacity: 0;
    width: 0;
    height: 0;
}
</style>
